import { createApi } from './axiosInstance';

const api = createApi('myFPO');
// mybusiness runs its own independent Notification API (NotificationController.java) - its own
// notifications table, for its own users - separate from fpo's. See NotificationContext.js's
// fetchNotifications() for why both have to be queried and merged (2026-09-17).
const myBusinessApi = createApi('myBusiness');

export const markAsRead = (id) => api.get(`/notification/${id}`);
export const markAsReadMyBusiness = (id) => myBusinessApi.get(`/notification/${id}`);

export const getNotifications = () => api.get(`/notification`);
export const getMyBusinessNotifications = () => myBusinessApi.get(`/notification`);
